import { Component, OnInit, OnDestroy } from '@angular/core';
import { ScrollService } from '../../api';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
  private event = null;
  private show: boolean = true;
  @BlockUI() blockUI: NgBlockUI;

  constructor(private scrollService: ScrollService) { }

  ngOnInit() {
    this.event = this.scrollService.progressBar.subscribe((event) => {
      this.show = event.data;
    });
  }

  ngOnDestroy() {
    if (this.event != null) {
      this.event.unsubscribe();
    }
    // setTimeout(() => {
      this.blockUI.stop();
    // }, 2000);

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/loader/loader.component.ts